import actionTypes from './actionTypes';

const milestones = (state = [], action) => {
    switch (action.type) {
        case actionTypes.MILESTONES_RESPONSE:
            return action.payload.response;
        default:
            return state;
    }
};

export default milestones;
